import { useState } from 'react';

export function FigmaFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "¿Es obligatorio el seguro para patinetes eléctricos?",
      answer: "Sí, desde el 30 de enero de 2026 es exigible el seguro obligatorio de Responsabilidad Civil para circular con patinete eléctrico en España."
    },
    {
      question: "¿Necesito registrar mi patinete en la DGT antes de contratar el seguro?",
      answer: "Sí, es necesario tener el patinete registrado en la DGT antes de contratar el seguro. El registro se puede hacer de forma telemática. La DGT cobra unas tasas por este trámite."
    },
    {
      question: "¿Cómo se paga el seguro?",
      answer: "El seguro se paga con tarjeta. El precio es de 99€/año para patinetes eléctricos."
    },
    {
      question: "¿Qué cubre el seguro en caso de accidente?",
      answer: "El seguro cubre Responsabilidad Civil hasta 7.750.000€ por siniestro (hasta 6.450.000€ de daños personales por siniestro cualquiera que sea el número de víctimas y hasta 1.300.000€ de daños materiales por siniestro), cumpliendo con la legislación vigente. Cubre daños personales y materiales a terceros causados durante la circulación."
    },
    {
      question: "¿Qué multa me pueden poner si circulo sin seguro?",
      answer: "Circular sin seguro obligatorio puede suponer una multa de hasta 800€ según la normativa de tráfico vigente."
    },
    {
      question: "¿Cómo dar parte de un accidente?",
      answer: "En caso de accidente, debes contactar con la aseguradora a través del área de cliente de la App de Movilidad de Linea Directa Aseguradora. Te guiarán en el proceso de declaración del siniestro."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-[32px] md:py-[48px]">
      <div className="container mx-auto px-4 max-w-[864px]">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] text-center mb-2">
          Preguntas frecuentes
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-center mb-[8px]">
          Resolvemos tus dudas sobre el seguro
        </p>

        <div className="bg-white border border-[#e5e7eb] rounded-[8px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border-b border-[#e5e7eb] last:border-b-0 ${index === 0 ? 'pt-[1px]' : ''}`}
            >
              <button 
                className="w-full text-left px-4 md:px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-[#101828] text-[13px] md:text-[14px] font-semibold leading-[18px] md:leading-[20px] pr-4">
                  {faq.question}
                </span>
                <svg 
                  className={`w-4 h-4 text-[#666666] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} 
                  fill="none" 
                  viewBox="0 0 16 16"
                >
                  <path d="M4 6L8 10L12 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4">
                  <p className="text-[#4a5565] text-[13px] md:text-[14px] leading-[18px] md:leading-[20px]">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}